import styled, { css } from "styled-components";
import userFill from "../../Assets/images/stars/user-fill.svg";
import starsGrey from "../../Assets/images/stars/stars-grey.svg";
import starsFull from "../../Assets/images/stars/stars-full.svg";

// Example: replace with your actual color value
const gold1 = "#b4a895"; // Replace with your actual gold color

export const FakeBannerAppRoot = styled("div")`
  &.fake-banner-app {
    position: fixed;
    max-width: 100%;
    width: 100%;
    display: flex;
    top: 0;
    left: 0;
    z-index: 1050;
    font-size: 0.75rem; /* rem(12) */
    line-height: 0.6875rem; /* rem(11) */
    background: linear-gradient(#fff, #f0f0f0);
    color: #000;

    @media (prefers-color-scheme: dark) {
      background: linear-gradient(#000, #101010);
      color: #fff;
    }

    button {
      background: transparent;
      border: none;
      margin: 0;
      outline: none;
      color: #000;
      @media (prefers-color-scheme: dark) {
        color: #fff;
      }
    }
    .close {
      min-width: 50px;
      padding: 0;
    }
    .fake-banner-app__labels {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px;
      margin: 0 auto 0 0;
      width: auto;
    }
    .fake-banner-app__icon {
      display: flex;
      margin: 0;
      justify-content: center;
      .icon {
        background: #000;
        margin: 10px auto;
        font-size: 40px;
        width: 1.4em;
        height: 1.4em;
        color: ${gold1};
        border-radius: 0.2em;
        border: solid 1px rgba(128, 128, 128, 0.5);
        display: flex;
        &:before {
          display: block;
          margin: auto;
        }
      }
    }
    .fake-banner-app__display-button {
      padding: 10px;
    }
    .fake-banner-app__name {
    }
    .o75 {
      opacity: 0.75;
    }
    .fake-banner-app__cta,
    .fake-banner-app__rating {
      font-size: 11px;
      line-height: 1em;
    }
    .fake-banner-app__name,
    .fake-banner-app__cta {
      overflow: hidden;
    }
    .fake-banner-app__rating {
      display: flex;
      margin: 3px 0;
      .fake-banner-app__rating__value {
        margin: 0 0 0 3px;
        &[data-count="0"] {
          display: none;
        }
      }
      .fake-banner-app__rating__count {
        display: inline-flex;
        &-icon:before {
          content: "";
          display: inline-flex;
          width: 10px;
          height: 10px;
          margin: 0 3px;
          background-image: url(${userFill});
          background-size: 10px 10px;
        }
        &-icon {
          &[data-count="0"] {
            &,
            & + span {
              display: none;
            }
          }
        }
      }
    }
    .fake-banner-app__star {
      display: inline-flex;
      width: 11px;
      height: 11px;
      background-image: url(${starsGrey});
      background-size: 11px 11px;
      &[data-p="1"] {
        background-image: url(${starsFull});
      }
      &[data-p^="0."] {
        &:before {
          content: "";
          display: block;
          width: 50%;
          background-size: 11px 11px;
          background-image: url(${starsFull});
        }
      }
    }
    @media screen and (max-width: 340px) {
      .close {
        min-width: 40px;
      }
      .fake-banner-app__icon {
        .icon {
          font-size: 28px;
        }
      }
    }
  }
`;
